// extracted by mini-css-extract-plugin
export default {"displayText":"modify-landing-page-name-modal__display-text__Uxlq1"};